import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBPQDdOTgR8X1U0jKf8eDyPui0IqxtpdBE',
  authDomain: 'recipedia-34b77.firebaseapp.com',
  databaseURL: 'https://recipedia-34b77.firebaseio.com',
  projectId: 'recipedia-34b77',
  storageBucket: 'recipedia-34b77.appspot.com',
  messagingSenderId: '742839818929',
  appId: '1:742839818929:web:9f644d75bbf7d05e27a090',
};

firebase.initializeApp(firebaseConfig);

export default firebase;
